import { FC, Fragment, useEffect, useState } from 'react';
import {
	getOrdersByVisit,
	toEndVisitOrder,
	toStartVisitForOrder,
	useOrderInfo,
} from 'entities/orders';
import { useModal } from 'shared/lib/modal';
import { PayloadAction } from '@reduxjs/toolkit';
import { withAsyncActionFeedback } from 'shared/ui/asyncAction';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { useAppDispatch } from 'shared/lib/store';
import { OrderDetailButtonsProps } from '../types';
import { getOrdersNext } from 'entities/orders/model/ordersThunk';

const ActionButtonContainedWithFeedback =
	withAsyncActionFeedback(ButtonContained);

export const OrderDetailMainButton: FC<OrderDetailButtonsProps> = ({
	goToBookingBtn,
	order,
	fetchData,
}) => {
	const { openModal } = useModal();
	const [nameButton, setNameButton] = useState('');
	const { selectedId, close } = useOrderInfo();
	const dispatch = useAppDispatch();

	const isVisitStarted = order?.status === 'visit_started';
	const successLabel = isVisitStarted
		? `Визит гостя ${order?.person?.name} завершился!`
		: `Визит гостя ${order?.person?.name} начался!`;

	useEffect(() => {
		if (isVisitStarted) {
			setNameButton('Гости ушли');
		} else {
			setNameButton('Гости пришли');
		}

		if (goToBookingBtn) {
			setNameButton('Перейти в бронирование');
		}
	}, [isVisitStarted, goToBookingBtn]);

	const handleSuccess = () => {
		if (isVisitStarted) {
			dispatch(getOrdersByVisit({}));
		}

		fetchData?.();
		close();
	};

	const accomodateGuest = async () => {
		if (selectedId) {
			await dispatch(toStartVisitForOrder({ id: selectedId }));
			return await dispatch(getOrdersNext({}));
		}
	};

	const seeOffGuest = async () => {
		if (selectedId) {
			return await dispatch(toEndVisitOrder({ id: selectedId }));
		}
	};

	const handleActionButton =
		async (): Promise<PayloadAction<unknown> | void> => {
			let actionResult;

			if (isVisitStarted) {
				actionResult = await seeOffGuest();
			} else {
				actionResult = await accomodateGuest();
			}

			return actionResult;
		};

	return (
		<Fragment>
			{goToBookingBtn ? (
				<ButtonContained
					isFullWidth={true}
					onClick={openModal}
					children={nameButton}
				/>
			) : (
				(order?.status === 'visit_started' ||
					order?.status === 'appointed') && (
					<ActionButtonContainedWithFeedback
						isFullWidth={true}
						onClick={handleActionButton}
						successToastLabel={successLabel}
						onSuccess={handleSuccess}
						children={nameButton}
					/>
				)
			)}
		</Fragment>
	);
};
